export default {
    isMainMenuOpen: true,
    roles: [],
    productUnits: [],
    gender: [],
    languages: [],
    deal: {
        fields: [],
        perceptions: [],
        status: []
    },
    incoming: {
        status: []
    },
    task: {
        status: []
    },
    quotation: {
        status: []
    },
    reports: {
        sales: {
            types: []
        }
    },
    emails: {
        status: [],
        senders: []
    },
    integrations: {
        approaches: []
    }
}



// WEBPACK FOOTER //
// ./src/store/global/state.js